/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingHomeIcon16Regular = forwardRef('BuildingHomeIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.381 3.506a2.25 2.25 0 0 1 3.238 0l4.841 5.015a.75.75 0 1 0 1.08-1.042l-4.842-5.015a3.75 3.75 0 0 0-5.396 0L.46 7.48a.75.75 0 0 0 1.08 1.042L6.38 3.506Z" }),
        React.createElement("path", { d: "M4.457 8.817a.75.75 0 1 0-1.5 0v3.366a2.75 2.75 0 0 0 2.75 2.75h4.586a2.75 2.75 0 0 0 2.75-2.75V8.817a.75.75 0 0 0-1.5 0v3.366c0 .69-.56 1.25-1.25 1.25H5.707c-.69 0-1.25-.56-1.25-1.25V8.817Z" })));
});
